import React from 'react'
import { Card, CardBody, Image, Box, Text, IconButton, Link, Icon, Button } from '@chakra-ui/react'
import { useCart } from '../../context/CartContext'
import { FaPlay } from 'react-icons/fa';
import { SlBasket } from 'react-icons/sl';
import { useMusicPlayer } from '../../context/MusicPlayerContext';
import { BeatIcon } from '../../tools/animatedIcons';




export default function Herocard({ item }) {
  const { addToCart } = useCart()

  const { playTrack, isPlaying, currentTrack } = useMusicPlayer();




  return (
    <Card w="100%" h={{ base: '400px', md: "500px" }} borderRadius="10px" position="relative" zIndex={2} overflow="hidden" bg="transparent">
      <Box
        background={`url(${item.item.image_url})`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        w="100%"
        h="100%"
        position="absolute"
        transition="transform 0.3s ease-in-out"
        _hover={{ transform: "scale(1.1)" }}
        zIndex="0"
        borderRadius="10px"
      />
      <CardBody

        display="flex"
        alignItems="flex-end"
        justifyContent={{ base: 'center', md: 'flex-start' }}

      >
        <Box
          h="100%"
          w={{ base: '100%', md: "20%" }}
          p={5}
          display="flex"
          justifyContent="flex-end"
          bg="dark.200"

          flexDirection="column"
          position="absolute"
          bottom="0"
          left="0"
          right="0"




        >
          <Image
            src={item.item.image_url}
            alt={item.track_name}
            borderRadius={4}
            w="50%"
            border="5px solid"
            borderColor="dark.900"
          />

          <Box>
            <Text color="dark.900" fontSize={20} fontWeight="900">{item.item.track_name}</Text>
            <Text as={Link} href={`/artist/${item.item.publisher.id}`} color="primary.900">{item.item.artist_name}</Text>
            <Text fontSize={30} color="primary.100" fontWeight="900">${item.item.price_per_share}</Text>
          </Box>


          <Box
            display="flex"

            alignItems="center"
            gap={2}
          >
     

            <IconButton
              variant="glassy"
              my={4}
              isDisabled={item.item.track_url === "" && item.item.preview_url === ""}
              onClick={(e) => {
                e.preventDefault();
                playTrack({
                  name: item.item.track_name,
                  artist: item.item.artist_name,
                  image: item.item.image_url,
                  url: item.item.preview_url ? item.item.preview_url : item.item.track_url,
                  track_id: item.item.track_id,
                  artist_id: item.item.publisher.id
                });
              }}
              icon={
                isPlaying && currentTrack.name === item.item.track_name ? (
                  <BeatIcon />
                ) : (
                  <Icon as={FaPlay} boxSize={6} />
                )
              }
              alignSelf="flex-start"
            >
              Play
            </IconButton>
            <IconButton
              icon={<SlBasket />}
              onClick={() => addToCart(item.item)}
              variant="glassy"

            />

          </Box>

          <Link href={`/track/${item.item.track_id}`}>

            <Button variant="ghost" px={2}
              bg="dark.200"
              color="dark.900"
              _hover={{ color: "primary.100" }}
            >View Track</Button>
          </Link>


        </Box>
      </CardBody>
    </Card>
  )
}
